import { INDEX_TO_KEY, BROWSER_LANGUAGE_MAP } from '../consts/language-options';

function getInitLocale() {
  let locale;
  const storageIndex = parseInt(localStorage.getItem('hik_connect_pro_locale'), 10);
  if (storageIndex >= 0) {
    locale = INDEX_TO_KEY[storageIndex];
  } else {
    const browserLocale = window.navigator.language;
    const localeKey = BROWSER_LANGUAGE_MAP[browserLocale];
    locale = INDEX_TO_KEY[localeKey] >= 0 ? localeKey : 'en';
  }
  localStorage.setItem('hik_connect_pro_locale', INDEX_TO_KEY[locale]);
  return locale;
}

export default getInitLocale;
